import { useQuery } from "@tanstack/react-query";
import { ExtractedFilesResultItem } from "../../../@types";
import api from "../../../api";
import { rlAuxiliaryAnalysisKeys } from "../react_query/queryKeys";

const useAuxiliaryExtractedFiles = (
  hash: string,
  extractedFilesQP: Record<string, unknown>,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const { data, error, isPending, isFetching, refetch } = useQuery({
    queryKey: rlAuxiliaryAnalysisKeys.extractedFiles(hash, extractedFilesQP),
    queryFn: () =>
      api
        .rlAuxiliaryAnalysisExtractedFiles(hash, extractedFilesQP)
        .then(resp => resp.data),
    enabled
  });

  const results: ExtractedFilesResultItem[] = data?.results ?? [];

  return {
    results,
    count: data?.count ?? 0,
    isLoading: enabled ? isPending : false,
    isFetching,
    error: error ? error.toString() : "",
    refetch
  };
};

export default useAuxiliaryExtractedFiles;
